import { useDispatch, useSelector } from 'react-redux';
import { toggleAlert } from 'redux/actions/alertActions';
import Markdown from 'components/Markdown';
import { event } from 'analytics';
import {
  BannerContainer,
  BannerIconContainer,
  BannerTextContainer,
} from './BannerAlertStyled';
import AlertIcon from 'components/Icons/AlertIcon';
import { useTranslate } from 'hooks/translation-hooks';
import { Banner } from '@integration/alexandria-ui';
import {
  currentLanguageSelector,
  emergencyBannerMessagesSelector,
  selectTheme,
} from 'redux/selectors/config';

const BANNER_ALERT_KEY = 'banner';

const BannerAlert = ({ message, category, closeAction }) => {
  const dispatch = useDispatch();
  const theme = useSelector(selectTheme);
  const currentLanguage = useSelector(currentLanguageSelector);
  const emergencyBannerMessages = useSelector(emergencyBannerMessagesSelector);
  const t = useTranslate();

  const closeBanner = () => {
    if (closeAction) {
      closeAction();
    } else {
      dispatch(toggleAlert(BANNER_ALERT_KEY));
    }
    event('close', category || 'special_event_banner');
  };

  return (
    <Banner
      bannerStyle={{
        colors: {
          bottomBorderColor: theme.specialBannerBorderBottom,
        },
      }}
      onClose={() => closeBanner()}
    >
      <BannerContainer>
        <BannerIconContainer>
          <AlertIcon />
        </BannerIconContainer>
        <BannerTextContainer>
          <Markdown
            text={
              message ||
              emergencyBannerMessages[currentLanguage] ||
              t('special_event_banner-text_1')
            }
          />
        </BannerTextContainer>
      </BannerContainer>
    </Banner>
  );
};

export default BannerAlert;
